import { Constants as G, AuthoringUtils as Q, ModelManager as D, PathUtils as F } from "@adobe/aem-spa-page-model-manager";
import { h as T, defineComponent as v, toRefs as W, computed as w, watch as V, ref as H, onMounted as J, onUnmounted as K, openBlock as i, createElementBlock as y, mergeProps as q, createBlock as P, resolveDynamicComponent as A, normalizeProps as g, guardReactiveProps as M, createCommentVNode as R, resolveComponent as L, normalizeClass as U, createElementVNode as X, Fragment as S, renderList as _ } from "vue";
import { ComponentMapping as O } from "@adobe/aem-spa-component-mapping";
import { ComponentMapping as Ve } from "@adobe/aem-spa-component-mapping";
function Y(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var k = {}, Z = {
  get exports() {
    return k;
  },
  set exports(e) {
    k = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  function o(E) {
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
      return typeof m;
    } : function(m) {
      return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
    }, o(E);
  }
  var n = 47, r = 46, a = function(m) {
    var u = o(m);
    if (u !== "string")
      throw new TypeError("Expected a string, got a ".concat(u));
  }, c = function(m, u) {
    for (var p = "", I = 0, d = -1, h = 0, b, C = 0; C <= m.length; ++C) {
      if (C < m.length)
        b = m.charCodeAt(C);
      else {
        if (b === n)
          break;
        b = n;
      }
      if (b === n) {
        if (!(d === C - 1 || h === 1))
          if (d !== C - 1 && h === 2) {
            if (p.length < 2 || I !== 2 || p.charCodeAt(p.length - 1) !== r || p.charCodeAt(p.length - 2) !== r) {
              if (p.length > 2) {
                var N = p.lastIndexOf("/");
                if (N !== p.length - 1) {
                  N === -1 ? (p = "", I = 0) : (p = p.slice(0, N), I = p.length - 1 - p.lastIndexOf("/")), d = C, h = 0;
                  continue;
                }
              } else if (p.length === 2 || p.length === 1) {
                p = "", I = 0, d = C, h = 0;
                continue;
              }
            }
            u && (p.length > 0 ? p += "/.." : p = "..", I = 2);
          } else
            p.length > 0 ? p += "/" + m.slice(d + 1, C) : p = m.slice(d + 1, C), I = C - d - 1;
        d = C, h = 0;
      } else
        b === r && h !== -1 ? ++h : h = -1;
    }
    return p;
  }, l = function(m) {
    try {
      return decodeURIComponent(m);
    } catch {
      return m;
    }
  }, f = function(m) {
    a(m);
    var u = m;
    if (u.length === 0)
      return ".";
    var p = u.charCodeAt(0) === n, I = u.charCodeAt(u.length - 1) === n;
    return u = l(u), u = c(u, !p), u.length === 0 && !p && (u = "."), u.length > 0 && I && (u += "/"), p ? "/" + u : u;
  }, j = f;
  t.default = j, e.exports = t.default;
})(Z, k);
const x = /* @__PURE__ */ Y(k), s = {
  logDebug(...e) {
    window != null && window.enableVueEditableComponentsLog && console.debug(...e);
  },
  logError(...e) {
    window != null && window.enableVueEditableComponentsLog && console.error(...e);
  },
  connectComponentWithItem(e, t, o, n, r, a, c = !1) {
    const l = this.getItemPath(e, n, c);
    t.inheritAttrs = !1;
    const f = {
      ...o,
      cqPath: l,
      isInEditor: a,
      containerProps: r
    };
    return T(t, f);
  },
  extractModelId(e) {
    return e && e.replace(/\/|:/g, "_");
  },
  getChildComponents(e, t, o, n, r, a, c) {
    const l = [];
    try {
      t && o && o.forEach((f) => {
        const j = s.modelToProps(t[f]), E = c.get(j.cqType);
        if (E) {
          const m = n(f);
          l.push(
            s.connectComponentWithItem(
              e,
              E,
              j,
              f,
              m,
              r,
              a
            )
          );
        }
      });
    } catch (f) {
      this.logError(
        "[aem-vue-editable-components/src/utils/Utils.ts] An error occurred in getChildComponents(). Returning an empty list.",
        "  - Error: ",
        f
      );
    }
    return l;
  },
  getChildPages(e, t) {
    const o = {};
    try {
      if (!e)
        return o;
      Object.keys(e).forEach((n) => {
        const r = s.modelToProps(e[n]), a = t.get(r.cqType);
        a && (o[n] = T(a, r));
      });
    } catch (n) {
      this.logError(
        "[aem-vue-editable-components/src/utils/Utils.ts] An error occurred in getChildPages(). Returning an empty list.",
        "  - Error: ",
        n
      );
    }
    return o;
  },
  getCQPath(e) {
    const { pagePath: t = "", itemPath: o = "", injectPropsOnInit: n } = e ?? {};
    let { cqPath: r = "" } = e ?? {};
    return n && !r && (r = x(
      o ? `${t}/jcr:content/${o}` : t
    ), r = r.replace(/^\.$/, "")), r;
  },
  getItemPath(e, t, o = !1) {
    let n = e ? `${e}/${t}` : t;
    return o && (n = e ? `${e}/${G.JCR_CONTENT}/${t}` : t), n;
  },
  isInEditor() {
    return Q.isInEditor();
  },
  modelToProps(e) {
    const t = {};
    try {
      const o = (r) => {
        const a = r.substring(1);
        return `cq${a.substring(0, 1).toUpperCase()}${a.substring(
          1
        )}`;
      };
      Object.getOwnPropertyNames(e).forEach((r) => {
        let a = r;
        a.startsWith(":") && (a = o(a)), t[a] = e[r];
      });
    } catch (o) {
      this.logError(
        "[aem-vue-editable-components/src/utils/Utils.ts] An error occurred in modelToProps(). Returning an empty list.",
        "  - Error: ",
        o
      );
    }
    return t;
  }
}, ee = v({
  name: "AemComponentWrapper",
  inheritAttrs: !1,
  props: {
    // Additional classes to add to the component (or its editable container, if it exists)
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    // The path in the page model tree that this component resides at,
    // e.g. /content/commercial-web-my-health-toolkit/sc/state/en/home/jcr:content/root/header_wrapper
    cqPath: {
      type: String,
      default: ""
    },
    // The component resource type,
    // e.g. commercial-web-my-health-toolkit/components/page
    cqType: {
      type: String,
      default: ""
    },
    // Properties about the AEM container that wraps this element.
    containerProps: {
      type: Object,
      default: () => ({})
    },
    // Configuration that is provided with the component for how it interacts with the drag & drop editor.
    editConfig: {
      type: Object,
      default: () => ({
        isEmpty: () => !1
      })
    },
    // ID attribute.
    id: {
      type: String,
      default: null
    },
    // Pass to override editor detection.
    isInEditor: {
      type: Boolean,
      default: null
    },
    // ???
    itemPath: {
      type: String,
      default: ""
    },
    // ???
    pagePath: {
      type: String,
      default: ""
    },
    // Configuration that controls how the component reacts to AEM model changes.
    reloadableModelConfig: {
      type: Object,
      default: () => ({})
    },
    // The Vue component that we want to display on the page.
    wrappedComponent: {
      type: Object,
      default: () => ({})
    }
  },
  errorCaptured(e, t, o) {
    s.logError(
      "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] An error was captured while rendering a component.",
      "  - Error: ",
      e,
      "  - Instance: ",
      t,
      "  - Info: ",
      o
    );
  },
  setup(e, { attrs: t }) {
    const { reloadableModelConfig: o } = W(e), n = w(() => o.value.forceReload ?? !1), r = w(() => o.value.injectPropsOnInit ?? !1), a = w(() => {
      var d;
      return ((d = e.containerProps) == null ? void 0 : d.aemNoDecoration) ?? !0;
    }), c = w(() => ({
      ...t,
      isInEditor: s.isInEditor(),
      aemNoDecoration: a.value
    })), l = w(() => {
      const {
        pagePath: d,
        itemPath: h,
        cqPath: b
      } = W(e);
      return s.getCQPath({
        pagePath: d.value,
        itemPath: h.value,
        injectPropsOnInit: r.value,
        cqPath: b.value
      });
    });
    V([l], ([d], [h]) => {
      try {
        h && (s.logDebug(
          "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Removing model change listener.",
          `  - Component Path: "${h}"`
        ), D.removeListener(
          h,
          j
        ));
      } catch {
      }
      s.logDebug(
        "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Adding model change listener.",
        `  - Component Path: "${d}"`
      ), D.addListener(
        d,
        j
      );
    }, { immediate: !0 });
    const f = H({});
    async function j(d) {
      const { pagePath: h, itemPath: b } = e;
      s.logDebug(
        "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Model Updated.",
        `  - Component Path: "${d}"`
      );
      const C = d || e.cqPath || h && s.getCQPath({ pagePath: h, itemPath: b, injectPropsOnInit: r.value });
      if (C)
        try {
          s.logDebug(
            "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Retrieving new model data.",
            `  - Component Path: "${C}"`
          );
          const N = await D.getData({ path: C, forceReload: n.value });
          s.logDebug(
            "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Got model data.",
            `  - Component Path: "${C}"`,
            "  - Data:",
            N
          ), N && Object.keys(N).length > 0 && (Object.assign(f.value, s.modelToProps(N)), r && s.isInEditor() && F.dispatchGlobalCustomEvent(
            "cq-async-content-loaded",
            {}
          ));
        } catch (N) {
          s.logError(
            "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] An error occurred when updating component model.",
            `  - Component Path: "${C}"`,
            "  - Error: ",
            N
          );
        }
    }
    J(() => {
      r.value && j(l.value);
    }), K(() => {
      try {
        s.logDebug(
          "[aem-vue-editable-components/src/editable/AemComponentWrapper.vue] Unmount - removing model change listener.",
          `  - Component Path: "${l.value}"`
        ), D.removeListener(
          l.value,
          j
        );
      } catch {
      }
    });
    const E = w(() => !(!s.isInEditor() && a.value)), m = w(() => {
      var b;
      const d = (e.appliedCssClassNames ?? "").split(
        " "
      );
      let h = [];
      return (b = e.containerProps) != null && b.class && (h = e.containerProps.class.split(" ")), e.cqType.endsWith("/container") && h.unshift("aem-editable"), [
        ...d,
        ...h
      ];
    }), u = w(() => {
      const d = {};
      return s.isInEditor() && (d["data-cq-data-path"] = l.value ?? "", e.editConfig.resourceType && (d["data-cq-resource-type"] = e.editConfig.resourceType)), d;
    }), p = w(() => s.isInEditor() && typeof e.editConfig.isEmpty == "function" && e.editConfig.isEmpty({
      ...c.value,
      ...f.value
    }) ? {
      class: "cq-placeholder",
      "data-emptytext": e.editConfig.emptyLabel
    } : {}), I = w(() => ({
      ...t,
      aemNoDecoration: a.value,
      appliedCssClassNames: e.appliedCssClassNames,
      componentProperties: c.value,
      containerProps: e.containerProps,
      cqForceReload: n.value,
      cqPath: l.value,
      cqType: e.cqType,
      editConfig: e.editConfig,
      id: e.id,
      isInEditor: s.isInEditor(),
      ...f.value
    }));
    return {
      showPlaceholder: w(() => s.isInEditor()),
      shouldCreateWrapperDiv: E,
      wrapperDivClassName: m,
      wrapperDivProperties: u,
      emptyPlaceholderProperties: p,
      wrappedComponentProperties: I
    };
  }
}), $ = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, r] of t)
    o[n] = r;
  return o;
};
function te(e, t, o, n, r, a) {
  return e.shouldCreateWrapperDiv ? (i(), y("div", q({
    key: 0,
    class: e.wrapperDivClassName
  }, e.wrapperDivProperties), [
    (i(), P(A(e.wrappedComponent), g(M(e.wrappedComponentProperties)), null, 16)),
    e.showPlaceholder ? (i(), y("div", g(q({ key: 0 }, e.emptyPlaceholderProperties)), null, 16)) : R("", !0)
  ], 16)) : (i(), P(A(e.wrappedComponent), g(q({ key: 1 }, e.wrappedComponentProperties)), null, 16));
}
const oe = /* @__PURE__ */ $(ee, [["render", te]]), ne = O.map, re = O.get, ae = (e, t, o) => {
  const n = {
    injectPropsOnInit: !0,
    forceReload: !1,
    ...o
  };
  return T(oe, {
    wrappedComponent: e,
    reloadableModelConfig: n,
    editConfig: t
  });
};
O.map = function(t, o, n = {
  isEmpty: (a) => !1
}, r = {}) {
  const { injectPropsOnInit: a = !1, ...c } = r || {}, l = ae(o, n, {
    injectPropsOnInit: a,
    ...c
  });
  return ne.call(O, t, l), l;
};
O.get = re;
const ke = (e) => (t, o, n = {}) => (
  // @ts-ignore
  O.map(e, t, o, n)
), se = v({
  name: "EditableComponent",
  inheritAttrs: !1,
  props: {
    aemNoDecoration: {
      type: Boolean,
      default: !0
    },
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    componentProperties: {
      type: Object,
      default: () => {
      }
    },
    containerProps: {
      type: Object,
      default: () => {
      }
    },
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqPath: {
      type: String,
      default: ""
    },
    cqType: {
      type: String,
      default: ""
    },
    editConfig: {
      type: Object,
      default: () => ({ isEmpty: (e) => !1 })
    },
    id: {
      type: String,
      default: null
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    },
    wrappedComponent: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e, t) {
  },
  computed: {
    editProps() {
      const e = {};
      return this.componentProperties.isInEditor && (e["data-cq-data-path"] = this.componentProperties.cqPath || "", this.editConfig.resourceType && (e["data-cq-resource-type"] = this.editConfig.resourceType)), e;
    },
    className() {
      var n, r;
      const { appliedCssClassNames: e } = this.componentProperties, t = (e || "").split(
        " "
      );
      let o = [];
      return (n = this.containerProps) != null && n.class && (o = this.containerProps.class.split(" ")), (r = this.cqType) != null && r.endsWith("/container") && o.unshift("aem-editable"), [
        ...t,
        ...o
      ];
    },
    shouldWrapWithDiv() {
      return !(!this.isInEditor && this.aemNoDecoration);
    },
    emptyPlaceholderProps() {
      return this.componentProperties.isInEditor && typeof this.editConfig.isEmpty == "function" && this.editConfig.isEmpty(this.componentProperties) ? {
        class: "cq-placeholder",
        "data-emptytext": this.editConfig.emptyLabel
      } : {};
    },
    wrappedComponentProps() {
      return {
        aemNoDecoration: this.aemNoDecoration,
        appliedCssClassNames: this.appliedCssClassNames,
        componentProperties: this.componentProperties,
        containerProps: this.containerProps,
        cqForceReload: this.cqForceReload,
        cqPath: this.cqPath,
        cqType: this.cqType,
        id: this.id,
        isInEditor: this.isInEditor,
        ...this.$attrs
      };
    }
  }
});
function ie(e, t, o, n, r, a) {
  return e.shouldWrapWithDiv ? (i(), y("div", q({
    key: 0,
    class: e.className
  }, { ...e.editProps }), [
    (i(), P(A(e.wrappedComponent), g(M(e.wrappedComponentProps)), null, 16)),
    e.isInEditor ? (i(), y("div", g(q({ key: 0 }, e.emptyPlaceholderProps)), null, 16)) : R("", !0)
  ], 16)) : (i(), P(A(e.wrappedComponent), g(q({ key: 1 }, e.wrappedComponentProps)), null, 16));
}
const le = /* @__PURE__ */ $(se, [["render", ie]]), pe = v({
  name: "CompositeEditableComponent",
  components: {
    EditableComponent: le
  },
  inheritAttrs: !1,
  props: {
    editConfig: {
      type: Object,
      default: () => {
      }
    },
    wrappedComponent: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e, t) {
  },
  computed: {
    computedProps() {
      var r, a;
      const e = this.editConfig || {
        isEmpty: () => !1
      }, t = ((r = this.$attrs) == null ? void 0 : r.isInEditor) || s.isInEditor(), o = ((a = this.$attrs) == null ? void 0 : a.containerProps) || {
        aemNoDecoration: !0
      };
      typeof o.aemNoDecoration > "u" && (o.aemNoDecoration = !0);
      const { aemNoDecoration: n } = o;
      return {
        ...this.$attrs,
        aemNoDecoration: n,
        componentProperties: {
          ...this.$attrs,
          isInEditor: t,
          aemNoDecoration: n
        },
        editConfig: e
      };
    }
  }
});
function ce(e, t, o, n, r, a) {
  const c = L("EditableComponent");
  return i(), P(c, q({ "wrapped-component": e.wrappedComponent }, e.computedProps), null, 16, ["wrapped-component"]);
}
const Te = /* @__PURE__ */ $(pe, [["render", ce]]), de = v({
  name: "ModelProvider",
  inheritAttrs: !1,
  props: {
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqPath: {
      type: String,
      default: ""
    },
    injectPropsOnInit: {
      type: Boolean,
      default: !1
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    },
    itemPath: {
      type: String,
      default: ""
    },
    pagePath: {
      type: String,
      default: ""
    },
    wrappedComponent: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      updatedProps: {},
      updateDataListener: (e) => {
      }
    };
  },
  computed: {
    updatedCqPath() {
      const {
        pagePath: e,
        itemPath: t,
        injectPropsOnInit: o,
        cqPath: n
      } = this.$props;
      return s.getCQPath({
        pagePath: e,
        itemPath: t,
        injectPropsOnInit: o,
        cqPath: n
      });
    }
  },
  mounted() {
    this.updateDataListener = this.updateData.bind(this);
    const e = this.updatedCqPath;
    this.injectPropsOnInit && this.updateData(e), D.addListener(
      e,
      this.updateDataListener
    );
  },
  unmounted() {
    const e = this.updatedCqPath;
    D.removeListener(
      e,
      this.updateDataListener
    );
  },
  methods: {
    updateData(e) {
      const { pagePath: t, itemPath: o, injectPropsOnInit: n } = this.$props, r = e || this.$props.cqPath || t && s.getCQPath({ pagePath: t, itemPath: o, injectPropsOnInit: n });
      r && D.getData({ path: r, forceReload: this.cqForceReload }).then((a) => {
        a && Object.keys(a).length > 0 && (Object.assign(this.updatedProps, s.modelToProps(a)), n && s.isInEditor() && F.dispatchGlobalCustomEvent(
          "cq-async-content-loaded",
          {}
        ));
      }).catch((a) => {
        console.log(a);
      });
    }
  }
});
function me(e, t, o, n, r, a) {
  return i(), P(A(e.wrappedComponent), g(M({
    ...e.$attrs,
    pagePath: e.pagePath,
    itemPath: e.itemPath,
    cqPath: e.updatedCqPath,
    ...e.updatedProps
  })), null, 16);
}
const ue = /* @__PURE__ */ $(de, [["render", me]]), he = v({
  name: "CompositeModelProvider",
  components: {
    ModelProvider: ue
  },
  inheritAttrs: !1,
  props: {
    wrappedComponent: {
      type: Object,
      default: () => {
      }
    },
    modelConfig: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e, t) {
  },
  computed: {
    cqForceReload() {
      var e;
      return ((e = this.modelConfig) == null ? void 0 : e.forceReload) || !1;
    },
    injectPropsOnInit() {
      var e;
      return ((e = this.modelConfig) == null ? void 0 : e.injectPropsOnInit) || !1;
    },
    isInEditor() {
      return s.isInEditor();
    }
  }
});
function fe(e, t, o, n, r, a) {
  const c = L("ModelProvider");
  return i(), P(c, q({
    "cq-force-reload": e.cqForceReload,
    "inject-props-on-init": e.injectPropsOnInit,
    "is-in-editor": e.isInEditor,
    "wrapped-component": e.wrappedComponent
  }, e.$attrs), null, 16, ["cq-force-reload", "inject-props-on-init", "is-in-editor", "wrapped-component"]);
}
const Be = /* @__PURE__ */ $(he, [["render", fe]]), Ce = v({
  name: "AllowedComponentPlaceholder",
  inheritAttrs: !1,
  props: {
    emptyLabel: {
      type: String,
      default: "No allowed components"
    },
    path: {
      type: String,
      default: ""
    }
  }
}), Pe = ["data-cq-data-path", "data-emptytext"];
function ye(e, t, o, n, r, a) {
  return i(), y("div", {
    "data-cq-data-path": e.path,
    "data-emptytext": e.emptyLabel,
    class: "aem-AllowedComponent--component cq-placeholder placeholder"
  }, null, 8, Pe);
}
const ge = /* @__PURE__ */ $(Ce, [["render", ye]]), be = v({
  name: "AllowedComponentsPlaceholderList",
  components: {
    AllowedComponentPlaceholder: ge
  },
  inheritAttrs: !1,
  props: {
    components: {
      type: Array,
      default: () => []
    },
    cqPath: {
      type: String,
      default: ""
    },
    emptyLabel: {
      type: String,
      default: "No allowed components"
    },
    placeholderProps: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      default: "Layout Container"
    }
  },
  computed: {
    listLabel() {
      return this.components && this.components.length > 0 ? this.title : this.emptyLabel;
    },
    placeholderClassNames() {
      var t, o;
      const e = [];
      return Array.isArray((t = this.placeholderProps) == null ? void 0 : t.placeholderClassNames) && e.push(
        ...(o = this.placeholderProps) == null ? void 0 : o.placeholderClassNames
      ), e.push("aem-AllowedComponent--list"), e;
    }
  }
}), qe = ["data-text"];
function ve(e, t, o, n, r, a) {
  const c = L("AllowedComponentPlaceholder");
  return i(), y("div", {
    class: U(e.placeholderClassNames)
  }, [
    X("div", {
      "data-text": e.listLabel,
      class: "aem-AllowedComponent--title"
    }, null, 8, qe),
    (i(!0), y(S, null, _(e.components, (l) => (i(), P(c, {
      key: l.toString(),
      "empty-label": l.title,
      path: l.path
    }, null, 8, ["empty-label", "path"]))), 128))
  ], 2);
}
const z = /* @__PURE__ */ $(be, [["render", ve]]), $e = v({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "ContainerPlaceholder",
  inheritAttrs: !1,
  props: {
    cqPath: {
      type: String,
      default: ""
    },
    placeholderClassNames: {
      type: Array,
      default: () => []
    }
  }
}), we = ["data-cq-data-path"];
function Ee(e, t, o, n, r, a) {
  return i(), y("div", {
    class: U(e.placeholderClassNames),
    "data-cq-data-path": `${e.cqPath}/*`
  }, null, 10, we);
}
const B = /* @__PURE__ */ $($e, [["render", Ee]]), Ie = v({
  name: "AllowedComponentsContainer",
  components: {
    AllowedComponentPlaceholderList: z,
    ContainerPlaceholder: B
  },
  inheritAttrs: !1,
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    _allowedComponentPlaceholderListEmptyLabel: {
      type: String,
      default: "No allowed components"
    },
    aemNoDecoration: {
      type: Boolean,
      default: !0
    },
    allowedComponents: {
      type: Object,
      default: () => {
      }
    },
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    columnClassNames: {
      type: Object,
      default: () => {
      }
    },
    componentMapping: {
      type: Object,
      default: new O()
    },
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqItems: {
      type: Object,
      required: !0
    },
    cqItemsOrder: {
      type: Array,
      required: !0
    },
    cqPath: {
      type: String,
      default: ""
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    },
    title: {
      type: String,
      default: "Layout Container"
    }
  },
  computed: {
    showAllowedComponentPlaceholderList() {
      return this.isInEditor && this.allowedComponents && this.allowedComponents.applicable;
    },
    emptyLabel() {
      return (
        // eslint-disable-next-line no-underscore-dangle
        this._allowedComponentPlaceholderListEmptyLabel || "No allowed components"
      );
    },
    childComponents() {
      return s.getChildComponents(
        this.cqPath,
        this.cqItems,
        this.cqItemsOrder,
        (e) => {
        },
        this.isInEditor,
        !1,
        this.componentMapping
      );
    },
    containerProps() {
      const e = {
        class: ["aem-container"]
      };
      return this.isInEditor && (e["data-cq-data-path"] = this.cqPath), e;
    },
    placeholderProps() {
      return {
        cqPath: this.cqPath,
        placeholderClassNames: ["new", "section"]
      };
    }
  }
});
function Ne(e, t, o, n, r, a) {
  const c = L("AllowedComponentPlaceholderList"), l = L("ContainerPlaceholder");
  return e.showAllowedComponentPlaceholderList ? (i(), P(c, {
    key: 0,
    components: e.allowedComponents.components,
    "cq-path": e.cqPath,
    "empty-label": e.emptyLabel,
    "placeholder-props": e.placeholderProps,
    title: e.title
  }, null, 8, ["components", "cq-path", "empty-label", "placeholder-props", "title"])) : (i(), y("div", g(q({ key: 1 }, e.containerProps)), [
    (i(!0), y(S, null, _(e.childComponents, (f) => (i(), P(A(f), {
      key: f.toString()
    }))), 128)),
    e.isInEditor ? (i(), P(l, g(q({ key: 0 }, e.placeholderProps)), null, 16)) : R("", !0)
  ], 16));
}
const We = /* @__PURE__ */ $(Ie, [["render", Ne]]), Ae = v({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Container",
  components: {
    ContainerPlaceholder: B
  },
  inheritAttrs: !1,
  props: {
    aemNoDecoration: {
      type: Boolean,
      default: !0
    },
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    componentMapping: {
      type: Object,
      default: new O()
    },
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqItems: {
      type: Object,
      required: !0
    },
    cqItemsOrder: {
      type: Array,
      required: !0
    },
    cqPath: {
      type: String,
      default: ""
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    }
  },
  computed: {
    childComponents() {
      return s.getChildComponents(
        this.cqPath,
        this.cqItems,
        this.cqItemsOrder,
        (e) => {
        },
        this.isInEditor,
        !1,
        this.componentMapping
      );
    },
    containerProps() {
      const e = {
        class: "aem-container"
      };
      return this.isInEditor && (e["data-cq-data-path"] = this.cqPath), e;
    },
    placeholderProps() {
      return {
        cqPath: this.cqPath,
        placeholderClassNames: ["new", "section"]
      };
    }
  }
});
function Oe(e, t, o, n, r, a) {
  const c = L("ContainerPlaceholder");
  return i(), y("div", g(M(e.containerProps)), [
    (i(!0), y(S, null, _(e.childComponents, (l) => (i(), P(A(l), {
      key: l.toString()
    }))), 128)),
    e.isInEditor ? (i(), P(c, g(q({ key: 0 }, e.placeholderProps)), null, 16)) : R("", !0)
  ], 16);
}
const Fe = /* @__PURE__ */ $(Ae, [["render", Oe]]), je = v({
  name: "Page",
  inheritAttrs: !1,
  props: {
    aemNoDecoration: {
      type: Boolean,
      default: !0
    },
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    componentMapping: {
      type: Object,
      default: new O()
    },
    cqChildren: {
      type: Object,
      default: () => {
      }
    },
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqItems: {
      type: Object,
      required: !0
    },
    cqItemsOrder: {
      type: Array,
      required: !0
    },
    cqPath: {
      type: String,
      default: ""
    },
    cssClassNames: {
      type: String,
      default: ""
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    }
  },
  setup(e) {
  },
  computed: {
    childComponents() {
      return s.getChildComponents(
        this.cqPath,
        this.cqItems,
        this.cqItemsOrder,
        (e) => {
        },
        this.isInEditor,
        !0,
        this.componentMapping
      );
    },
    childPages() {
      return s.getChildPages(this.cqChildren, this.componentMapping);
    },
    containerProps() {
      const e = {
        class: ["aem-page", this.cssClassNames]
      };
      return this.isInEditor && (e["data-cq-data-path"] = this.cqPath), e;
    }
  },
  mounted() {
    this.$attrs.title && (document.title = this.$attrs.title);
  },
  updated() {
    this.$attrs.title && (document.title = this.$attrs.title);
  }
});
function Le(e, t, o, n, r, a) {
  return i(), y("div", g(M(e.containerProps)), [
    (i(!0), y(S, null, _(e.childComponents, (c) => (i(), P(A(c), {
      key: c.toString()
    }))), 128)),
    (i(!0), y(S, null, _(e.childPages, (c, l) => (i(), P(A(c), { key: l }))), 128))
  ], 16);
}
const Ue = /* @__PURE__ */ $(je, [["render", Le]]), De = v({
  name: "ResponsiveGrid",
  inheritAttrs: !1,
  props: {
    aemNoDecoration: {
      type: Boolean,
      default: !0
    },
    _allowedComponentPlaceholderListEmptyLabel: {
      type: String,
      default: "No allowed components"
    },
    allowedComponents: {
      type: Object,
      default: () => {
      }
    },
    appliedCssClassNames: {
      type: String,
      default: ""
    },
    columnClassNames: {
      type: Object,
      default: () => {
      }
    },
    componentMapping: {
      type: Object,
      default: new O()
    },
    cqForceReload: {
      type: Boolean,
      default: !1
    },
    cqItems: {
      type: Object,
      required: !0
    },
    cqItemsOrder: {
      type: Array,
      required: !0
    },
    cqPath: {
      type: String,
      default: ""
    },
    gridClassNames: {
      type: String,
      default: ""
    },
    isInEditor: {
      type: Boolean,
      default: s.isInEditor()
    },
    title: {
      type: String,
      default: "Layout Container"
    }
  },
  components: {
    AllowedComponentPlaceholderList: z,
    ContainerPlaceholder: B
  },
  computed: {
    showAllowedComponentPlaceholderList() {
      return this.isInEditor && this.allowedComponents && this.allowedComponents.applicable;
    },
    emptyLabel() {
      return (
        // eslint-disable-next-line no-underscore-dangle
        this._allowedComponentPlaceholderListEmptyLabel || "No allowed components"
      );
    },
    childComponents() {
      const e = (t) => {
        let o = "";
        return this.columnClassNames && this.columnClassNames[t] && (o = this.columnClassNames[t]), {
          aemNoDecoration: this.aemNoDecoration,
          class: o
        };
      };
      return s.getChildComponents(
        this.cqPath,
        this.cqItems,
        this.cqItemsOrder,
        e,
        this.isInEditor,
        !1,
        this.componentMapping
      );
    },
    containerProps() {
      const e = {
        class: ["aem-container", this.gridClassNames]
      };
      return this.isInEditor && (e["data-cq-data-path"] = this.cqPath), e;
    },
    placeholderProps() {
      return {
        cqPath: this.cqPath,
        placeholderClassNames: ["new", "section", "aem-Grid-newComponent"]
      };
    }
  }
});
function Se(e, t, o, n, r, a) {
  const c = L("AllowedComponentPlaceholderList"), l = L("ContainerPlaceholder");
  return e.showAllowedComponentPlaceholderList ? (i(), P(c, {
    key: 0,
    components: e.allowedComponents.components,
    "cq-path": e.cqPath,
    "empty-label": e.emptyLabel,
    "placeholder-props": e.placeholderProps,
    title: e.title
  }, null, 8, ["components", "cq-path", "empty-label", "placeholder-props", "title"])) : (i(), y("div", g(q({ key: 1 }, e.containerProps)), [
    (i(!0), y(S, null, _(e.childComponents, (f) => (i(), P(A(f), {
      key: f.toString()
    }))), 128)),
    e.isInEditor ? (i(), P(l, g(q({ key: 0 }, e.placeholderProps)), null, 16)) : R("", !0)
  ], 16));
}
const ze = /* @__PURE__ */ $(De, [["render", Se]]);
export {
  ge as AllowedComponentPlaceholder,
  z as AllowedComponentPlaceholderList,
  We as AllowedComponentsContainer,
  Ve as ComponentMapping,
  Te as CompositeEditableComponent,
  Be as CompositeModelProvider,
  Fe as Container,
  B as ContainerPlaceholder,
  le as EditableComponent,
  ke as MapTo,
  ue as ModelProvider,
  Ue as Page,
  ze as ResponsiveGrid,
  s as Utils,
  ae as withMappable
};
